import accountApi from 'api/accountApi';
import feApi from 'api/feApi';
import store from 'app/store';
import AuthHelper from 'features/Auth/authHelper';
import { setAgencyRoleList, setPermissionList, updateUser } from 'features/Auth/authSlice';
import AppRoute from 'general/constants/AppRoute';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import ToastHelper from 'general/helpers/ToastHelper';
import RoleUtils from 'general/utils/RoleUtils';
import Utils from 'general/utils/Utils';
import { t } from 'i18next';

const AccountHelper = {
  // ---- methods ----
  callApiGetProfile: async () => {
    try {
      let res;
      const savedActiveRole = localStorage.getItem(PreferenceKeys.savedActiveRole);
      const savedUiMode = localStorage.getItem(PreferenceKeys.savedUiMode);
      if (!RoleUtils.isAdminUiRole(savedActiveRole) && RoleUtils.isCustomerUiMode(savedUiMode)) {
        res = await feApi.getProfile();
      } else {
        res = await accountApi.getProfile();
      }
      const { result } = res;
      const profile = res.profile ?? res.user;
      if (result == 'success') {
        if (!profile) {
          AuthHelper.signOut();
          Utils.openInCurrentTab(`${AppRoute.auth}/sign-in`);
          return null;
        }
        if (RoleUtils.isAdminUiRole(profile?.role)) {
          localStorage.setItem(PreferenceKeys.savedActiveRole, `${profile?.role || ''}`.trim().toUpperCase());
          localStorage.setItem(PreferenceKeys.savedUiMode, RoleUtils.uiModes.cms);
        }
        store.dispatch(updateUser(profile));
        store.dispatch(setAgencyRoleList(RoleUtils.getAgencyRoles(profile)));

        const permissionList = profile?.permissionGroup?.permissions?.map((permission) => {
          return { path: permission.fe_path, code: permission.code };
        });
        store.dispatch(setPermissionList(permissionList));
        return profile;
      }
      return null;
    } catch (error) {
      const statusCode = error?.response?.status;
      if (statusCode == 401 || statusCode == 403) {
        ToastHelper.showError(t('message401error'));
        AuthHelper.signOut();
        Utils.openInCurrentTab(AppRoute.auth);
      } else if (!error.response) {
        // MOCK USER PROFILE SO FRONTEND CAN LOAD WITHOUT BACKEND
        const mockUser = {
          userId: 1,
          email: 'admin@evhub.com',
          role: 'ADMIN',
          permissionGroup: {
            permissions: []
          }
        };
        store.dispatch(updateUser(mockUser));
        ToastHelper.showWarning('Backend offline. Đang dùng tài khoản Mock để test giao diện.');
      }
      return null;
    }
  },

  checkAccountPermission: (permissionCode, permissionList) => {
    if (!permissionList || !Array.isArray(permissionList) || permissionList.length === 0) {
      return true;
    }

    return permissionList.some((permission) => permission?.code === permissionCode);
  },

  callApiUpdateUser: async (userId, params) => {
    try {
      const res = await accountApi.updateUser(userId, params);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },
};

export default AccountHelper;
